// extracted by mini-css-extract-plugin
module.exports = {"root":"MediumCheckboxWrapper_root__1K7y0"};